export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
export const DAY_ABBR = ["Mon", "Tue", "Wed", "Thu", "Fri"];

export const PROJECT_INFO = {
  title: "Website Redesign",
  client: "Al Noor Real Estate",
  resourcesAllocated: 12,
  description: "A Digital Campaign Promoting Ramadan Season Properties",
};

export const STATUS_CONFIG = {
  Available: { label: "AVAILABLE", textColor: "#16a34a", bg: "#dcfce7" },
  "On Leave": { label: "ON LEAVE",  textColor: "#dc2626", bg: "#fee2e2" },
  "Half Day": { label: "HALF DAY",  textColor: "#d97706", bg: "#fef3c7" },
};

// Per-resource card colours (border + background tint + name colour)
const COLORS = [
  { border: "#14b8a6", bg: "#f0fdfa", nameColor: "#0d9488" },   // teal  – JW
  { border: "#14b8a6", bg: "#f0fdfa", nameColor: "#0d9488" },   // teal  – MW
  { border: "#14b8a6", bg: "#f0fdfa", nameColor: "#0d9488" },   // teal  – RH
  { border: "#f87171", bg: "#fff1f2", nameColor: "#dc2626" },   // pink  – JK
  { border: "#fbbf24", bg: "#fffbeb", nameColor: "#d97706" },   // amber – JC
];

export const MOCK_RESOURCES = [
  {
    id: 1,
    name: "James Wilson",
    initials: "JW",
    role: "Graphic Designer",
    department: "Design",
    status: "Available",
    task: "Creating social media creatives for property promotion",
    startDay: "Monday",
    daySpan: 4,
    color: COLORS[0],
  },
  {
    id: 2,
    name: "Martin Warner",
    initials: "MW",
    role: "Digital Marketing Specialist",
    department: "Marketing",
    status: "On Leave",
    task: "Managing paid ad campaigns for property launch",
    startDay: "Tuesday",
    daySpan: 4,
    color: COLORS[1],
  },
  {
    id: 3,
    name: "Ruby Hastings",
    initials: "RH",
    role: "Content Writer",
    department: "Content",
    status: "Half Day",
    task: "Writing website content and blog articles for new properties",
    startDay: "Wednesday",
    daySpan: 3,
    color: COLORS[2],
  },
  {
    id: 4,
    name: "Justin Kale",
    initials: "JK",
    role: "Motion Designer",
    department: "Design",
    status: "Available",
    task: "Producing short promotional videos for Instagram ads",
    startDay: "Tuesday",
    daySpan: 4,
    color: COLORS[3],
  },
  {
    id: 5,
    name: "Jack Clerk",
    initials: "JC",
    role: "Social Media Manager",
    department: "Marketing",
    status: "Available",
    task: "Scheduling posts and managing engagement on social platforms",
    startDay: "Monday",
    daySpan: 2,
    color: COLORS[4],
  },
];